(() => {
  if (window.FuxinLanguageSwitchLoaded) return;
  window.FuxinLanguageSwitchLoaded = true;

  const normalizeLocale = (locale) => {
    const value = (locale || '').toLowerCase().replaceAll('_', '-');
    return { 'zh-cn': 'zh-hans', 'zh-tw': 'zh-hant' }[value] || value;
  };

  const findLanguageUrl = (locale) => {
    const language = normalizeLocale(locale);
    const links = Array.from(document.querySelectorAll('link[rel="alternate"][hreflang]'));
    let link = links.find((item) => normalizeLocale(item.hreflang) === language);
    if (!link && language.includes('-') && !language.startsWith('zh-')) {
      // Shopify advertises Brazilian Portuguese as hreflang="pt" here.
      const baseMatches = links.filter((item) => normalizeLocale(item.hreflang) === language.split('-')[0]);
      if (baseMatches.length === 1) link = baseMatches[0];
    }
    if (!link) return null;
    try {
      const url = new URL(link.href, window.location.href);
      // Changing Markets or domains still goes through Shopify's form.
      if (url.origin !== window.location.origin) return null;
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
      const current = new URL(window.location.href);
      const existingKeys = new Set(url.searchParams.keys());
      current.searchParams.forEach((value, key) => {
        if (!existingKeys.has(key)) url.searchParams.append(key, value);
      });
      url.hash = current.hash;
      return url.href;
    } catch {
      return null;
    }
  };

  let pending = null;
  let recoveryTimer;
  const reset = () => {
    window.clearTimeout(recoveryTimer);
    // Browsers can restore the selected field after a normal back navigation,
    // even when the page was reloaded rather than restored from bfcache.
    document.querySelectorAll('localization-form-component[data-current-language]').forEach((component) => {
      component.removeAttribute('aria-busy');
      const select = component.querySelector('select[name="language_code"]');
      if (!select) return;
      select.removeAttribute('aria-disabled');
      select.value = component.dataset.currentLanguage;
    });
    pending = null;
  };

  // Register independently of Horizon's module graph, including on mobile.
  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || select.name !== 'language_code') return;
    const component = select.closest('localization-form-component[data-current-language]');
    const form = select.form;
    if (!component || !form) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending) {
      select.value = pending.language;
      return;
    }
    if (normalizeLocale(select.value) === normalizeLocale(component.dataset.currentLanguage)) return;

    const language = select.value;
    const url = form.querySelector('[name="country_code"]') ? null : findLanguageUrl(language);
    pending = { component, select, language };
    component.setAttribute('aria-busy', 'true');
    // Do not disable the field: Shopify's fallback needs its submitted value.
    select.setAttribute('aria-disabled', 'true');
    recoveryTimer = window.setTimeout(reset, 15000);
    try {
      if (url) {
        window.location.assign(url);
      } else {
        HTMLFormElement.prototype.submit.call(form);
      }
    } catch {
      reset();
    }
  }, true);
  window.addEventListener('pageshow', reset);
})();
